import { PropTypes } from 'prop-types';
import React from 'react';

const CustomerInlineLabelInput = ({ label, input, labelClass, inputClass, type, placeholder, isEditable, meta, id }) => (
  <div className="form-group columns">
    <label className={ labelClass } id={ `${ id }-label` }>{label}</label>
    <input
      { ...input }
      className={ inputClass }
      type={ type }
      value={ input?.value ?? '' }
      placeholder={ placeholder }
      disabled={ !isEditable }
      id={ id }
    />
  </div>
);

CustomerInlineLabelInput.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  isEditable: PropTypes.bool,
  meta: PropTypes.shape().isRequired,
  input: PropTypes.shape({
    value: PropTypes.any
  }).isRequired,
  id: PropTypes.string,
  labelClass: PropTypes.string,
  inputClass: PropTypes.string
};

CustomerInlineLabelInput.defaultProps = {
  placeholder: '',
  type: 'text',
  isEditable: true,
  id: null,
  labelClass: 'form-label col-3',
  inputClass: 'form-input col-8'
};

export default CustomerInlineLabelInput;
